/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPencilDiscount = createReactComponent("pencil-discount", "IconPencilDiscount", [
  [
    "path",
    {
      d: "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4",
      key: "svg-0"
    }
  ],
  ["path", { d: "M13.5 6.5l4 4", key: "svg-1" }],
  ["path", { d: "M16 21l5 -5", key: "svg-2" }],
  ["path", { d: "M21 21v.01", key: "svg-3" }],
  ["path", { d: "M16 16v.01", key: "svg-4" }]
]);

export { IconPencilDiscount as default };
//# sourceMappingURL=IconPencilDiscount.js.map
